module.exports = __webpack_public_path__ + "static/menu-bullet-294c711d6bfaf72c533eac51c121876f.svg";